import { defineStore } from 'pinia';

export const useTouStore = defineStore({
    id: 'tou',
    state: () => ({
        touLoginUrl: null, // タフネスログインURL。ログアウト時の遷移先として使用する。
        touProfileUrl: null, // エラー画面でタフネスに設定を行わないといけない場合の画面のURL。
    }),
    getters: {},
    actions: {
        reset() {
            this.touLoginUrl = null; // タフネスログインURL。ログアウト時の遷移先として使用する。
            this.touProfileUrl = null; // エラー画面でタフネスに設定を行わないといけない場合の画面のURL。
        },
    },
    persist: {
        // セッショントレージに保存する。
        storage: sessionStorage,
    },
});
